var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rp-loading-dots"},_vm._l((_vm.dotsLength),function(value,index){return _c('div',{key:'rp-loading-dots'+index,staticClass:"rp-loading-dots--dot",style:(_vm.stylesForLoader)})}))}
var staticRenderFns = []

export { render, staticRenderFns }